import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { LocaleProvider } from "./i18n.tsx";
import "./styles.css";
import "./game-world.css";

const root = document.getElementById("root");
if (!root) throw new Error("NeckMoves app root is missing");

createRoot(root).render(<StrictMode><LocaleProvider><App /></LocaleProvider></StrictMode>);
document.getElementById("seo-fallback")?.remove();
document.documentElement.classList.add("app-ready");
